import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { createQueryClient } from './QueryClient';
import { AuthProvider } from '@/contexts/AuthContext';
import { ActivityScopeProvider } from '@/contexts/ActivityScopeContext';
import { GamificationFxProvider } from '@/contexts/GamificationFxContext';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { AppToaster } from '@/components/common/AppToaster';
import i18n from '@/i18n';

const queryClient = createQueryClient();

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <ActivityScopeProvider>
                <GamificationFxProvider>
                  {children}
                  <AppToaster />
                </GamificationFxProvider>
              </ActivityScopeProvider>
            </AuthProvider>
          </BrowserRouter>
          {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />}
        </QueryClientProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}
